"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiUrl = exports.getIsFeatureFlagEnabled = exports.isFeatureFlagEnabled = exports.useFeatureFlag = void 0;
const selectors_1 = require("./selectors");
const env_1 = require("../../utils/env");
const CoreConfiguration_1 = __importDefault(require("../../config/CoreConfiguration"));
const config_1 = require("../../utils/config");
const hooks_1 = require("../../store/hooks");
const useFeatureFlag = (featureFlagName) => {
    const featureFlags = (0, hooks_1.useAppSelector)(selectors_1.selectFeatureFlags);
    return (0, exports.getIsFeatureFlagEnabled)({
        featureFlags,
        featureFlagName,
    });
};
exports.useFeatureFlag = useFeatureFlag;
const isFeatureFlagEnabled = (featureFlagName) => {
    const config = (0, config_1.getGlobalConfig)();
    const featureFlags = config === null || config === void 0 ? void 0 : config.FEATURE_FLAGS;
    if (!featureFlags)
        return false;
    return (0, exports.getIsFeatureFlagEnabled)({
        featureFlags,
        featureFlagName,
    });
};
exports.isFeatureFlagEnabled = isFeatureFlagEnabled;
const getIsFeatureFlagEnabled = ({ featureFlags, featureFlagName, }) => {
    var _a;
    return (_a = featureFlags[featureFlagName]) !== null && _a !== void 0 ? _a : false;
};
exports.getIsFeatureFlagEnabled = getIsFeatureFlagEnabled;
const getApiUrl = () => {
    const urlFromConfig = CoreConfiguration_1.default.getInstance().apiUrl;
    if (urlFromConfig)
        return urlFromConfig;
    const config = (0, config_1.getGlobalConfig)();
    const apiUrl = config.API_URL;
    return config.isDevelopment && env_1.isBrowser ? '/api' : apiUrl;
};
exports.getApiUrl = getApiUrl;
//# sourceMappingURL=utils.js.map